import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW9007Component } from './kymw9007.component';
import { SendPasswordResetEmailService } from './api-services/send-password-reset-email.service';

/**
 * 2要素認証画面 モジュール設定クラス
 *
 * @export KYMW9007Module
 * @class KYMW9007Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9007Component,
  ],
  providers: [
    SendPasswordResetEmailService,
  ]
})
export class KYMW9007Module {

}
